/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectBreakdownTable_viewer = {
    readonly permissions: ReadonlyArray<string | null> | null;
    readonly project: {
        readonly id: string;
        readonly name: string | null;
        readonly rateCard: {
            readonly currency: string | null;
        } | null;
        readonly tasks: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly expenseItems: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly allocations: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly startYear: number | null;
                    readonly startMonth: number | null;
                    readonly startDay: number | null;
                    readonly endYear: number | null;
                    readonly endMonth: number | null;
                    readonly endDay: number | null;
                } | null;
            } | null> | null;
        } | null;
        readonly groupedFinancialNumbers: ReadonlyArray<{
            readonly personId: number | null;
            readonly taskId: number | null;
            readonly expenseId: number | null;
            readonly allocationId: number | null;
            readonly scopeTotalMinutes: number | null;
            readonly plannedRevenue: number | null;
            readonly plannedCost: number | null;
            readonly plannedRevenueProfit: number | null;
            readonly plannedRevenueMargin: number | null;
            readonly allPlannedTimeAndExpenses: number | null;
            readonly registeredMinutes: number | null;
            readonly totalActualRevenueRecognition: number | null;
            readonly actualCost: number | null;
            readonly actualRevenueProfit: number | null;
            readonly actualRevenueMargin: number | null;
            readonly allActualTimeAndExpenses: number | null;
            readonly forecastTimeToComplete: number | null;
            readonly totalForecastRevenueToComplete: number | null;
            readonly forecastCostToComplete: number | null;
            readonly forecastRevenueProfitToComplete: number | null;
            readonly forecastRevenueMarginToComplete: number | null;
            readonly allForecastTimeAndExpensesToComplete: number | null;
        } | null> | null;
        readonly baselineGroupedFinancialNumbers: ReadonlyArray<{
            readonly roleId: number | null;
            readonly expenseCategoryId: number | null;
            readonly baselineMinutes: number | null;
            readonly baselineTimeAndExpenses: number | null;
            readonly baselineCost: number | null;
            readonly baselineProfit: number | null;
            readonly baselineMargin: number | null;
            readonly baselineRevenue: number | null;
        } | null> | null;
        readonly useBaseline: boolean | null;
    } | null;
    readonly company: {
        readonly id: string;
        readonly currency: string | null;
        readonly roles: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly expenseCategories: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly name: string | null;
                } | null;
            } | null> | null;
        } | null;
        readonly allPersons: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly firstName: string | null;
                    readonly lastName: string | null;
                    readonly profilePictureId: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": "ProjectBreakdownTable_viewer";
};
export type ProjectBreakdownTable_viewer$data = ProjectBreakdownTable_viewer;
export type ProjectBreakdownTable_viewer$key = {
    readonly " $data"?: ProjectBreakdownTable_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProjectBreakdownTable_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v4 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v5 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId",
      "type": "ID"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectBreakdownTable_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RateCard",
          "kind": "LinkedField",
          "name": "rateCard",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "TaskTypeConnection",
          "kind": "LinkedField",
          "name": "tasks",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TaskTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Task",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "tasks(first:1000000)"
        },
        {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "ExpenseItemTypeConnection",
          "kind": "LinkedField",
          "name": "expenseItems",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExpenseItemTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ExpenseItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "expenseItems(first:1000000)"
        },
        {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "AllocationTypeConnection",
          "kind": "LinkedField",
          "name": "allocations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AllocationTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Allocation",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startYear",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startMonth",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endYear",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endMonth",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endDay",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "allocations(first:1000000)"
        },
        {
          "alias": null,
          "args": [
            (v5/*: any*/),
            {
              "kind": "Literal",
              "name": "groupBy",
              "value": [
                "PERSON",
                "TASK",
                "EXPENSE",
                "ALLOCATION"
              ]
            }
          ],
          "concreteType": "FinancialNumbers",
          "kind": "LinkedField",
          "name": "groupedFinancialNumbers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "personId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "taskId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expenseId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allocationId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scopeTotalMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedRevenue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedCost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedRevenueProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedRevenueMargin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allPlannedTimeAndExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "registeredMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalActualRevenueRecognition",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualCost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualRevenueProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualRevenueMargin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allActualTimeAndExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastTimeToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalForecastRevenueToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastCostToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastRevenueProfitToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastRevenueMarginToComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allForecastTimeAndExpensesToComplete",
              "storageKey": null
            }
          ],
          "storageKey": "groupedFinancialNumbers(convertToProjectCurrency:true,groupBy:[\"PERSON\",\"TASK\",\"EXPENSE\",\"ALLOCATION\"])"
        },
        {
          "alias": "baselineGroupedFinancialNumbers",
          "args": [
            (v5/*: any*/),
            {
              "kind": "Literal",
              "name": "groupBy",
              "value": [
                "ROLE",
                "EXPENSE_CATEGORY"
              ]
            }
          ],
          "concreteType": "FinancialNumbers",
          "kind": "LinkedField",
          "name": "groupedFinancialNumbers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "roleId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expenseCategoryId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineTimeAndExpenses",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineCost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineProfit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineMargin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "baselineRevenue",
              "storageKey": null
            }
          ],
          "storageKey": "groupedFinancialNumbers(convertToProjectCurrency:true,groupBy:[\"ROLE\",\"EXPENSE_CATEGORY\"])"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useBaseline",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": (v6/*: any*/),
          "concreteType": "RoleTypeConnection",
          "kind": "LinkedField",
          "name": "roles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "roles(first:10000)"
        },
        {
          "alias": null,
          "args": (v6/*: any*/),
          "concreteType": "ExpenseCategoryTypeConnection",
          "kind": "LinkedField",
          "name": "expenseCategories",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ExpenseCategoryTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ExpenseCategory",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v4/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "expenseCategories(first:10000)"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 100000
            }
          ],
          "concreteType": "PersonTypeConnection",
          "kind": "LinkedField",
          "name": "allPersons",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profilePictureId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "allPersons(first:100000)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '9c22020efc7215613f99d92d597281a6';
export default node;
